export enum InvoiceType {
    'nfe' = 'nfe',
    'nfse' = 'nfse'
}
